define('modules/media/iframer',['require','exports','module','modules/media/binder','app'],function(require, exports, module) {"use strict";

	var Binder = require("modules/media/binder");
	var app = require("app");
	//	var AdobeEdge = require("animate");
	//	var LoaderEdge = require("animate_loader");

	return module.exports = {

		load : function(elements,media) {
			
			
		

			if (!elements.getAttribute('data_loaded')) {
				
				
				elements.className+= " noSwipingClass";

				var ifr = document.createElement("iframe");
				ifr.src = media.src;
				elements.querySelectorAll('.iframecnt')[0].appendChild(ifr);
 				elements.setAttribute('data_loaded',true);

				//	myIframe.contentWindow.postMessage('hello', '*');

				//https://gist.github.com/localpcguy/1373518

			} else {

				//this.scaleStage(media.id, media.w, media.h,this.rescaler[el.id]);

				/*	if (this.must_play[media.id]) {

				try {

				var sym = window.AdobeEdge.getComposition(media.id).getStage();
				sym.onStart();
				} catch(ex) {

				}

				}*/

				////console.log ('video già assegnato');

			}

		},

		rewind : function(id, media) {

			//////console.log ('MUST REWIND' , media,   id );

			if (this.must_leave[media]) {

				try {
					var sym = window.AdobeEdge.getComposition(media).getStage();
					sym.onLeave();

				} catch(er) {

				}
			}

		}
	};

});

